// extracted by mini-css-extract-plugin
module.exports = {"AnswerItem":"AnswerItem_AnswerItem__19BNj","success":"AnswerItem_success__2mnz9","error":"AnswerItem_error__1yrvI"};